import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value, round = false, len = 4) {
  if (!value) {
    return '0'
  }
  let decStr = ''
  value = value.toString().split('.')[0]
  
  if (round && value.length > len) {
    value = Number(value) / 10000
    if (value % 1 !== 0) { // value 不是整数
      const valueStrArr = value.toString().split('.')
      value = valueStrArr[0]
      const dec = valueStrArr[1].substr(0, 2)
      Number(dec) && (decStr = `.${dec}`)
    } 
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat + decStr
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
